import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { APP_ROUTES } from '@core/routes/app-routes';
// import { Auth } from 'aws-amplify';
// import axios from 'axios';
import { AwsService } from '__services';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpService } from './http.service';
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  setNewPassword: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  confirmSMS: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  loginValue: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  preventLogout: boolean = false;

  constructor(
    private router: Router,
    private http: HttpService,
    private awsService: AwsService
  ) {}

  // login(email: string, password: string): Promise<any> {
  //   return Auth.signIn(email, password);
  // }

  // checkAccount(email: string, password: string): Promise<any> {
  //   return Auth.signIn({ username: email, password: password, validationData: {validate: false} });
  // }

  logout(): void {
    this.logLogout();
  }

  logLogout() {
    this.http.post('/users/logout', {expired: false}).subscribe(
      (res) => {
        this.awsService.logout().finally(() => {
          this.redirectToLogin();
        });
        // Auth.signOut({ global: true }).then(
        //   () => {
        //     this.redirectToLogin();
        //   },
        //   (err) => {
        //     if (err?.code === 'NotAuthorizedException') {
        //       this.redirectToLogin();
        //     }
        //   }
        // );
      },
      (err) => {
        // if(err && err.name === 'UnauthorizedError') {
          this.redirectToLogin();
        // }
        console.log(err);
      }
    )
  }

  redirectToLogin(): void {
    this._clearStorage();
    // localStorage.clear();
    this.router.navigate([APP_ROUTES.LOGIN]);
  }

  private _clearStorage() {
    var values = [],
      keys = Object.keys(localStorage),
      i = keys.length;

    let keysForRememberDevices = [
      'deviceKey',
      'deviceGroupKey',
      'randomPasswordKey',
      'clockDrift',
      'userLang'
    ];

    keys.forEach((key) => {
      if (!keysForRememberDevices.some(element => key.includes(element))) {
        localStorage.removeItem(key);
      }
    });

    return values;
  }

  // setPassword(user: any, password: string): Promise<any> {
  //   return Auth.completeNewPassword(user, password);
  // }

  // sendCode(username: string): Promise<any> {
  //   return Auth.forgotPassword(username);
  // }

  resendEmail(body): Observable<any> {
    return this.http.post('/admin/users/resend-initial-password', body);
  }

  // resetPassword(
  //   username: string,
  //   code: string,
  //   password: string
  // ): Promise<any> {
  //   return Auth.forgotPasswordSubmit(username, code, password);
  // }

  // getInfoCognitoUser(): Promise<any> {
  //   return Auth.currentAuthenticatedUser();
  // }

  // completeNewPassword(user, password, requireAttributes?) {
  //   return Auth.completeNewPassword(user, password, requireAttributes || null);
  // }

  // getUserAttributes() {
  //   return Auth.currentUserInfo();
  // }

  // getAccessToken(): Promise<any> {
  //   return Auth.currentSession()
  //     .then((res) => res.getAccessToken().getJwtToken())
  //     .catch((err) => {});
  // }

  // getRefreshToken(): Promise<any> {
  //   return Auth.currentSession()
  //     .then((res) => res.getRefreshToken().getToken())
  //     .catch((err) => {});
  // }

  // getIdentityToken(): Promise<any> {
  //   return Auth.currentSession()
  //     .then((res) => res.getIdToken())
  //     .catch((err) => {});
  // }

  /**
   * Gets the cognito identity url.
   *
   * @return     {string}  The cognito identity url.
   */
  // _getCognitoIdentityURL () {
  //   const region = ENV.awsConfig.Auth.region;
  //   const url = 'https://cognito-identity.' + region + '.amazonaws.com/';
  //   return url;
  // }

  /**
   * Gets the cognito identity browser identifier.
   * @see https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetId.html
   *
   * @param      {<type>}   token   The token
   * @return     {Promise}  The cognito identity browser identifier.
   */
  // async _getCognitoIdentityBrowserId(token) {
  //   const { region, identityPoolId, userPoolId } = ENV.awsConfig.Auth;
  //   if (!token) {
  //     token = await this.getIdentityToken();
  //   }
  //   const _url = this._getCognitoIdentityURL();
  //   const payload = {
  //     "IdentityPoolId": identityPoolId,
  //     "Logins": {}
  //   }

  //   const key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
  //   payload.Logins[key] = token.jwtToken;

  //   const res = await axios.post(_url, payload, {
  //     headers: {
  //       "amz-sdk-request": "attempt=1; max=3",
  //       "content-type": "application/x-amz-json-1.1",
  //       "x-amz-target": "AWSCognitoIdentityService.GetId"
  //     }
  //   });

  //   if (res.data && !res.data.IdentityId) {
  //     return;
  //   }

  //   return res.data.IdentityId;
  // }

  /**
   * Manually gets the current credentials.
   * @see https://docs.aws.amazon.com/cognitoidentity/latest/APIReference/API_GetCredentialsForIdentity.html
   *
   * @return     {Promise}  The current credentials.
   */
  // async _getCurrentCredentials() {
  //   const { region, userPoolId } = ENV.awsConfig.Auth;
  //   const token = await this.getIdentityToken();
  //   const browserIdentityId = await this._getCognitoIdentityBrowserId(token);
  //   const _url = this._getCognitoIdentityURL();

  //   // Build Payload
  //   const payload = {
  //     "IdentityId": browserIdentityId,
  //     "Logins": {}
  //   }
  //   const key = 'cognito-idp.' + region + '.amazonaws.com/' + userPoolId;
  //   payload.Logins[key] = token.jwtToken;

  //   const res = await axios.post(_url, payload, {
  //     headers: {
  //       "amz-sdk-request": "attempt=1; max=3",
  //       "content-type": "application/x-amz-json-1.1",
  //       "x-amz-target": "AWSCognitoIdentityService.GetCredentialsForIdentity"
  //     }
  //   });

  //   if (res.data && !res.data.Credentials) {
  //     return {};
  //   }

  //   return {
  //     "identityId": res.data.IdentityId,
  //     "accessKeyId": res.data.Credentials.AccessKeyId,
  //     "secretAccessKey": res.data.Credentials.SecretKey,
  //     "sessionToken": res.data.Credentials.SessionToken,
  //     "expiration": res.data.Credentials.Expiration,
  //     "authenticated": true
  //   }
  // }

  async getTempCredentials() {
    // const credentials = await Auth.currentCredentials().catch();
    const credentials = await this.awsService.fetchAuthSession();
    // If it can't get current credentials by amplify auth,
    // let get it by manually.
    // if (!credentials || !credentials.accessKeyId) {
    //   const _credentials = await this._getCurrentCredentials();
    //   return _credentials;
    // }
    return credentials;
  }

  // changePassword(oldPassword, newPassword): Promise<any> {
  //   return Auth.currentAuthenticatedUser().then((res) =>
  //     Auth.changePassword(res, oldPassword, newPassword)
  //   );
  // }

  callLogin() {
    const headerDict = {
      login: 'login',
    };
    return this.http.get(`/profiles`, {}, headerDict);
  }

  getUserInfo(): Observable<any> {
    return this.http.get(`/profiles`);
  }
  updateUserInfo(profile): Observable<any> {
    return this.http.patch(`/profiles`, profile);
  }

  updateUserSettings(settings): Observable<any> {
    return this.http.patch(`/profiles/settings`, settings);
  }

  // updateUserAttributes(user, profile): Promise<any> {
  //   return Auth.updateUserAttributes(user, profile);
  // }

  // setPreferredMFA(user) {
  //   return Auth.setPreferredMFA(user, 'SMS');
  // }

  // disableMFA(user) {
  //   return Auth.setPreferredMFA(user, 'NOMFA');
  // }

  // verifyCurrentUserAttribute(attr) {
  //   return Auth.verifyCurrentUserAttribute(attr);
  // }

  // verifyCurrentUserAttributeSubmit(attr, code): Promise<any> {
  //   return Auth.verifyCurrentUserAttributeSubmit(attr, code);
  // }

  // getPreferredMFA(user) {
  //   return Auth.getPreferredMFA(user);
  // }

  // enableSMS(user) {
  //   return Auth.setPreferredMFA(user, 'SMS');
  // }

  // confirmSignIn(user, code) {
  //   return Auth.confirmSignIn(user, code, 'SMS_MFA');
  // }

  getUserActivities(params): Observable<any> {
    return this.http.get(`/profiles/activities`, params);
  }

  deleteUserProfile(): Observable<any> {
    return this.http.delete(`/profiles`);
  }
}
